import { render, staticRenderFns } from "./PeledakanViewNew.vue?vue&type=template&id=ab445ce0&scoped=true&lang=pug&"
import script from "./PeledakanViewNew.vue?vue&type=script&lang=js&"
export * from "./PeledakanViewNew.vue?vue&type=script&lang=js&"
import style0 from "./PeledakanViewNew.vue?vue&type=style&index=0&id=ab445ce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab445ce0",
  null
  
)

export default component.exports